/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VwStoricoAnnoDtoFromJSON, VwStoricoAnnoDtoToJSON, } from './VwStoricoAnnoDto';
/**
 * Check if a given object implements the VwStoricoAnnoPagedDto interface.
 */
export function instanceOfVwStoricoAnnoPagedDto(value) {
    return true;
}
export function VwStoricoAnnoPagedDtoFromJSON(json) {
    return VwStoricoAnnoPagedDtoFromJSONTyped(json, false);
}
export function VwStoricoAnnoPagedDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'content': json['content'] == null ? undefined : (json['content'].map(VwStoricoAnnoDtoFromJSON)),
        'size': json['size'] == null ? undefined : json['size'],
        'page': json['page'] == null ? undefined : json['page'],
        'totalElements': json['totalElements'] == null ? undefined : json['totalElements'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
    };
}
export function VwStoricoAnnoPagedDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'content': value['content'] == null ? undefined : (value['content'].map(VwStoricoAnnoDtoToJSON)),
        'size': value['size'],
        'page': value['page'],
        'totalElements': value['totalElements'],
        'totalPages': value['totalPages'],
    };
}
